import React from 'react';
import { FormattedMessage } from '@99designs/frontend-components/i18n';
import { AnswerLink } from '../../components/Step/AnswerLink';
import { STEP_BRANDING_STAGE } from '../constants';
import type { SelectedValues } from '../config';
import type { BrandingStageValue } from './BrandingStageStepInputs';

interface BrandingStageStepAnswerProps {
    link: string;
    data: SelectedValues;
    onClick: () => void;
}

const answerCopy = (): Record<BrandingStageValue, string> => ({
    new: __('new'),
    existing: __('existing'),
});

const answerMessage = (): Record<BrandingStageValue, string> => ({
    new: __('I want to create {brandingStage} branding.'),
    existing: __('I have {brandingStage} branding.'),
});

export function BrandingStageStepAnswer({ data, link, onClick }: BrandingStageStepAnswerProps) {
    const value = data[STEP_BRANDING_STAGE];
    if (!value) {
        return null;
    }

    return (
        <FormattedMessage
            message={answerMessage()[value]}
            values={{
                brandingStage: (
                    <AnswerLink href={link} onClick={onClick}>
                        {answerCopy()[value]}
                    </AnswerLink>
                ),
            }}
        />
    );
}
